import script from "./ScriptEmailStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScriptEmailStep.vue?vue&type=script&lang=ts&setup=true"

import "./ScriptEmailStep.vue?vue&type=style&index=0&id=31da6637&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31da6637"]])

export default __exports__